import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-learn-question-answer',
  templateUrl: './learn-question-answer.component.html',
  styleUrls: ['./learn-question-answer.component.scss'],
  standalone: false
})
export class LearnQuestionAnswer {

  isLoadingFeedback: boolean = false;
  learnset?: Learnset;

  stack?: Flashcard[];
  currentFlashcard?: Flashcard;
  currentFlashcardSide: 'front' | 'back' = 'front';

  text: string = '';
  
  sessionId?: number;

  totalCards: number = 0;
  cardsProgress: number = 0;
  cumulativeScore: number = 0;
  learnedCards: number = 0;

  feedbackTitle?: string;
  feedbackMessage?: string;
  feedbackScore?: number;
  feedbackColor?: 'success' | 'warn' | 'error';
  showFeedback: boolean = false;

  allCardsFinished: boolean = false;

  constructor(
    private learnsetService: LearnsetService,
    private flashcardService: FlashcardService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const learnsetId = this.route.snapshot.paramMap.get('id');
    this.fetchLearnset(learnsetId!);
  }

  fetchLearnset(learnsetId: string): void {
    this.learnsetService.getLearnset(learnsetId)
      .subscribe((learnset: any) => {
        this.learnset = Learnset.constructLearnset(learnset);
        this.stack = JSON.parse(JSON.stringify(this.learnset.flashcards.filter((flashcard) => flashcard.dueDate! < new Date())));
        this.totalCards = this.stack!.length;
        this.currentFlashcard = this.stack![0];
      });
  }

  submitAnswer() {
    this.isLoadingFeedback = true;
    this.flashcardService.getAnswerFeedback(this.currentFlashcard!.id!, this.text).subscribe((result: any) => {
      this.learnedCards++;
      this.isLoadingFeedback = false;
      this.currentFlashcardSide = 'back';
      this.showFeedback = true;
      this.text = '';
      this.feedbackTitle = result.feedbackTitle;
      this.feedbackMessage = result.feedbackMessage;
      this.cardsProgress = (100 / this.totalCards) * this.learnedCards;
      
      if (this.cardsProgress === 100) {
        this.allCardsFinished = true;
      }

      this.cumulativeScore += result.score;
      this.feedbackScore = result.score;
      this.feedbackColor = this.getFeedbackColor(result.score);
    });
  }

  getFeedbackColor(score: number): 'success' | 'warn' | 'error' {
    if (score >= 4) {
      return 'success';
    } else {
      return 'warn';
    }
  }

  nextCard() {
    this.stack!.splice(0, 1);
    this.currentFlashcard = this.stack![0];
    this.showFeedback = false;
    this.currentFlashcardSide = 'front';
  }

  finishSession() {
    this.router.navigate(['/sets/' + this.learnset?.id]);
  }
}
